import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { environment } from '@env/environment';
import { Subscription } from 'rxjs';
import { LocalService } from '@core/services/local.service';
@Component({
  standalone: false,
  selector: 'app-management-groups',
  templateUrl: './management-groups.component.html',
  styleUrls: ['./management-groups.component.scss']
})
export class ManagementGroupsComponent implements OnInit {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  constructor(private permissionStore: PermissionStore, private authService: AuthService, private sessionStorage: LocalService) {
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      console.log('ManagementGroupsComponent');
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production
        }
      };
    });
  }

  ngOnInit(): void {
    console.log();
  }
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
